import React from 'react';

const TABS = [
  {
    id: 'alerts',
    label: 'Anomaly alerts',
    shortLabel: 'Alerts',
    icon: (active) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill={active ? 'var(--accent)' : 'none'} stroke={active ? 'none' : 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    ),
    iconSmall: (active) => (
      <svg width="14" height="14" viewBox="0 0 24 24" fill={active ? 'var(--accent)' : 'none'} stroke={active ? 'none' : 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    ),
  },
  {
    id: 'history',
    label: 'Prediction history',
    shortLabel: 'Predictions',
    icon: (active) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? 'var(--accent)' : 'var(--muted)' }}>
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
    iconSmall: (active) => (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? 'var(--accent)' : 'var(--muted)' }}>
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
  },
  {
    id: 'chart',
    label: 'Chart history',
    shortLabel: 'History',
    icon: (active) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? 'var(--accent)' : 'var(--muted)' }}>
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <path d="M3 9h18M9 21V9"/>
      </svg>
    ),
    iconSmall: (active) => (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? 'var(--accent)' : 'var(--muted)' }}>
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <path d="M3 9h18M9 21V9"/>
      </svg>
    ),
  },
  {
    id: 'cluster',
    label: 'Cluster map',
    shortLabel: 'Clusters',
    icon: (active) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? 'var(--accent)' : 'var(--muted)' }}>
        <circle cx="7" cy="8" r="2"/><circle cx="17" cy="6" r="2"/>
        <circle cx="10" cy="15" r="2"/><circle cx="19" cy="14" r="2"/>
        <circle cx="5" cy="17" r="2"/>
      </svg>
    ),
    iconSmall: (active) => (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? 'var(--accent)' : 'var(--muted)' }}>
        <circle cx="7" cy="8" r="2"/><circle cx="17" cy="6" r="2"/>
        <circle cx="10" cy="15" r="2"/><circle cx="19" cy="14" r="2"/>
        <circle cx="5" cy="17" r="2"/>
      </svg>
    ),
  },
  {
    id: 'hiw',
    label: 'How it works',
    shortLabel: 'How it works',
    icon: (active) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? 'var(--accent)' : 'var(--muted)' }}>
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    ),
    iconSmall: (active) => (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? 'var(--accent)' : 'var(--muted)' }}>
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    ),
  },
];

export default function TabBar({ activeTab, onTabChange }) {
  return (
    <>
      {/* Desktop top tab bar */}
      <div className="tabbar-top" style={{
        display: 'flex', alignItems: 'center',
        background: 'var(--surface)',
        borderBottom: '1px solid var(--border)',
        padding: '0 12px', overflowX: 'auto',
        scrollbarWidth: 'none', msOverflowStyle: 'none'
      }}>
        {TABS.map(t => {
          const active = activeTab === t.id;
          return (
            <div
              key={t.id}
              onClick={() => onTabChange(t.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                fontSize: '12px', padding: '5px 12px',
                borderRadius: '20px', cursor: 'pointer',
                whiteSpace: 'nowrap', margin: '6px 3px',
                border: `1px solid ${active ? 'var(--accent-bd)' : 'transparent'}`,
                background: active ? 'var(--accent-bg)' : 'transparent',
                color: active ? 'var(--accent)' : 'var(--muted)',
                fontWeight: active ? 500 : 400,
                transition: 'all 0.15s',
              }}
              onMouseEnter={e => {
                if (!active) {
                  e.currentTarget.style.background = 'var(--track-bg)';
                  e.currentTarget.style.color = 'var(--sub)';
                }
              }}
              onMouseLeave={e => {
                if (!active) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = 'var(--muted)';
                }
              }}
            >
              {t.iconSmall(active)}
              {t.label}
            </div>
          );
        })}
      </div>

      {/* Mobile bottom nav — Style B */}
      <div className="tabbar-bottom" style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        background: 'var(--surface)', borderTop: '1px solid var(--border)',
        height: '56px', zIndex: 50,
        alignItems: 'center', padding: '0 4px'
      }}>
        {TABS.map(t => {
          const active = activeTab === t.id;
          return (
            <div
              key={t.id}
              onClick={() => onTabChange(t.id)}
              style={{
                flex: 1, display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center', gap: '3px',
                cursor: 'pointer', padding: '6px 4px',
                background: active ? 'var(--accent-bg)' : 'transparent',
                borderRadius: '10px', height: '44px',
                transition: 'background 0.15s'
              }}
            >
              {t.icon(active)}
              <span style={{
                fontSize: '9px', fontWeight: active ? 500 : 400,
                color: active ? 'var(--accent)' : 'var(--muted)',
                whiteSpace: 'nowrap'
              }}>
                {t.shortLabel}
              </span>
            </div>
          );
        })}
      </div>
    </>
  );
}